export const cmv = {
	searchProduct: "Encuentre un producto",
	searchPlaceholder: "Seleccione un producto o categoría",
	details: {
		salePrice: "Precio de Venta",
		cost: "Costo",
		realCost: "Costo Real",
		markup: "Markup",
		contributionMargin: "M. de Contrib.",
		productSimulator: "Simulador de CMV",
		editProductPrice: "Cambiar Precio",
	},
	supply: {
		columns: {
			input: "Insumo",
			quantity: "Cant",
			unitCost: "Costo Unitario",
			loss: "Pérdida",
			realCost: "Costo Real",
		},
	},
};
